import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { errorResponseSchema, successResponseSchema } from '../schemas/common.schemas';

const c = initContract();

const knowledgeDocumentSchema = z.object({
  id: z.string().uuid(),
  documentId: z.string(),
  filename: z.string(),
  contentType: z.string(),
  agentType: z.string().nullable(),
  fileSize: z.number(),
  chunkCount: z.number(),
  status: z.string(),
  uploadedAt: z.coerce.date(),
  processedAt: z.coerce.date().nullable(),
});

export const knowledgeContract = c.router({
  uploadDocument: {
    method: 'POST',
    path: '/knowledge/upload',
    contentType: 'multipart/form-data',
    body: z.object({
      documentId: z.string().min(1),
      agentType: z.string().optional(),
      file: z.any(), // File will be handled by NestJS FileInterceptor
    }),
    responses: {
      201: knowledgeDocumentSchema,
      400: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Upload a knowledge document (PDF, Markdown, or Text)',
  },
  listDocuments: {
    method: 'GET',
    path: '/knowledge/documents',
    query: z.object({
      agentType: z.string().optional(),
      status: z.string().optional(),
    }),
    responses: {
      200: z.object({
        documents: z.array(knowledgeDocumentSchema),
      }),
      401: errorResponseSchema,
    },
    summary: 'List knowledge documents',
  },
  getDocument: {
    method: 'GET',
    path: '/knowledge/documents/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    responses: {
      200: knowledgeDocumentSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Get knowledge document by ID',
  },
  deleteDocument: {
    method: 'DELETE',
    path: '/knowledge/documents/:id',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: z.object({}),
    responses: {
      200: successResponseSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Delete knowledge document and all its chunks',
  },
  updateDocumentAgent: {
    method: 'PATCH',
    path: '/knowledge/documents/:id/agent',
    pathParams: z.object({
      id: z.string().uuid(),
    }),
    body: z.object({
      agentType: z.string().nullable(),
    }),
    responses: {
      200: knowledgeDocumentSchema,
      404: errorResponseSchema,
      401: errorResponseSchema,
    },
    summary: 'Update document agent assignment',
  },
});
